export default function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section className="relative bg-[hsl(var(--primary))] text-white overflow-hidden grain">
      <div className="container-x py-20 sm:py-28 relative z-10">
        {eyebrow && <div className="label-eyebrow text-white/80 mb-4">{eyebrow}</div>}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-base sm:text-lg max-w-2xl text-white/85 leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      <div className="absolute -right-20 -bottom-20 w-96 h-96 bg-[hsl(var(--accent))]/20 blur-3xl rounded-full" />
    </section>
  );
}
